import AppContext from '../../context/AppContext'

import {
  FailureContainer,
  FailureImg,
  FailureHeading,
  FailurePara,
  FailureButton,
} from './styledComponents'

const FailureView = props => {
  const {
    onClickSearchButton,
    videoItemDetailsRetryBtn,
    trendingRetryBtn,
    gamingRetryBtn,
    path,
  } = props
  console.log(path)
  const onClickRetryButton = () => {
    if (path === '/') {
      onClickSearchButton()
    } else if (path === '/videos/:id') {
      videoItemDetailsRetryBtn()
    } else if (path === '/trending') {
      trendingRetryBtn()
    } else if (path === '/gaming') {
      gamingRetryBtn()
    }
  }
  return (
    <AppContext.Consumer>
      {value => {
        const {theme} = value
        return (
          <FailureContainer>
            <>
              {theme === true ? (
                <FailureImg
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png"
                  alt="failure view"
                />
              ) : (
                <FailureImg
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png"
                  alt="failure view"
                />
              )}
              <FailureHeading theme={theme}>
                Oops! Something Went Wrong
              </FailureHeading>
              <FailurePara theme={theme}>
                We are having some trouble completing your request. Please try
                again
              </FailurePara>
              <FailureButton theme={theme} onClick={onClickRetryButton}>
                Retry
              </FailureButton>
            </>
          </FailureContainer>
        )
      }}
    </AppContext.Consumer>
  )
}

export default FailureView
